import { useCallback, useState } from "react";

export const useUsernameCheck = () => {
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(false);
  const [isDebouncing, setIsDebouncing] = useState(false);
  const [isCheckingUsername, setIsCheckingUsername] = useState(false);

  const checkAvailable = useCallback((available: boolean) => {
    setIsUsernameAvailable(available);
  }, []);

  const checkDebouncing = useCallback((debouncing: boolean) => {
    setIsDebouncing(debouncing);
  }, []);
  const checkLoading = useCallback((loading: boolean) => {
    setIsCheckingUsername(loading);
  }, []);

  return {
    isUsernameAvailable,
    checkAvailable,
    isDebouncing,
    checkDebouncing,
    isCheckingUsername,
    checkLoading,
  };
};
